import React from 'react';
import ConfirmEmailForm from './ConfirmEmailForm';

const ConfirmEmail = () =>
  <div className="text-center">
    <h5 className='mb-0'>¿Ya estás registrado y aún no posees un enlace de verificación?</h5>
    <ConfirmEmailForm />
  </div>

export default ConfirmEmail;
